<div class="my-container" [hidden]="!loading"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
<div class='alert alert-danger malert-danger' *ngIf="err_validation">{{ err }}</div>
<div class='alert alert-danger malert-danger' *ngIf="err_internet_validation">{{ err_internet_text }} <span><i class="fas fa-sync icon" ></i></span></div>

<div mat-dialog-title class="matDialogTitle">
  <span> صورت وضعیت مونتاژ و نصب </span>
  <span class="close" (click)="close()" ><mat-icon>close</mat-icon></span>
</div>

<!-- height: 100vh !important;overflow: scroll !important; -->
<div mat-dialog-content class="matDialogContent print" style="height: 100vh !important;">
  <div class="container" style="width:100%">
    <div class="row">
      <div class='col-md-12 col-sm-12 col-xs-12 col-lg-12 col-12 class-form'>
        <span> بسمه تعالی</span>
        <div class='col-md-12 col-sm-12 col-xs-12 col-lg-12 col-12 class-form-line'>
          <div class='form-line-right'>
            <span>
            <span style='color:red'>ه</span>
            <span>وشمندسازه</span>
            </span>
          </div>
          <div class='form-line-left'>
            فرم صورت وضعیت مونتاژ و نصب
          </div>
          <div class='form-line-right' style="border: none;">
              </div>
              <div class='form-line-left' style="border: none;">
              <span class='span-f'>
                <span>تاریخ :</span>
                <span>------</span>
              </span>
              <span class='span-f'>
                <span>شماره :</span>
                <span>------</span>
              </span>
            </div>
        </div>
      </div><!-- col-md-12 col-sm-12 col-xs-12 col-lg-12 col-12 -->
    </div><!-- row -->

    <div class="row row2 row1">
        <div class='col-md-12 col-sm-12 col-xs-12 col-lg-12 col-12'>
         مدیر محترم اجرایی
         <br>
         با سلام
         <br>
         احتراما" با توجه به ارسال بار پروژه مذکور نسبت به انتصاب نصاب مورد نظر تصمیم لازم را اتخاذ نمائید.
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 col-12" style="padding-top:2rem;text-align:left">مدیر فروش</div>
    </div><!-- row -->


    <div class="row row2">
      <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
        نام کارفرما:
      </div>
      <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
          نام کارفرما:
      </div>
      <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-13  div2'>
        شماره مشتری:
      </div>
    </div><!-- row -->

    <div class="row row1 row2">
      <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
          موقعیت اجرا:
      </div>
      <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
          امکانات سایت:
      </div>
      <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
          تعداد طبقات:
      </div>
      <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
          زیربنا:
      </div>
      <div class='col-lg-12 col-12 col-md-12 col-sm-12 col-xs-3 div2'>
          محل:
      </div>
    </div><!-- row -->


    <div class="row row2">
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
          نام پیمانکار:
        </div>
        <div class='col-lg-3 col-3 col-md-3 col-sm-3col-xs-3 div2'>
          شماره قرارداد:
        </div>
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
            تاریخ قرارداد:
        </div>
    </div><!-- row -->

    
    <div class="row row1 row2">
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
          تاریخ شروع به کار:
        </div>
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
           تاریخ نصب دیوارها:
        </div>
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
            تاریخ نصب سقف نهایی:
        </div>
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
            تاریخ جمع آوری  :
        </div>
    </div><!-- row -->

    <div class="row row2">
        <div class='col-lg-12 col-12 col-md-12 col-sm-12 col-xs-3 div2'>
            تعداد پیچ های مورد استفاده:
        </div>
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
          سازه:
        </div>
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
           بکس:
        </div>
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
            بلت میان طبقات:
        </div>
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
            بلت کف:
        </div>
    </div><!-- row -->

    <div class="row row1 row2">
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
          ارسال عکس:
        </div>
        <div class='col-lg-3 col-3 col-md-3 col-sm-3 col-xs-3 div2'>
           به صورت:
        </div>
        <div style="padding-top:2rem;text-align:left">امضا نصاب</div>

    </div><!-- row -->

    <div class="row row2 row1">
        <div class='col-md-12 col-sm-12 col-xs-12 col-lg-12 col-12'>
          شرکت هوشمند سازه
         <br>
         با سلام
         <br>
         احتراما اینجانب ........ کارفرمای پروژه ........ رضایت خود را نسبت به نصب سازه توسط پیمانکار فوق و درجه کیفی وی را بد/متوسط/خوب اعلام می دارم
         <div style="padding-top:2rem;text-align:left">کارفرما</div>
        </div>
    </div><!-- row -->

    <div class="row row2 row1">
        <div class='col-md-12 col-sm-12 col-xs-12 col-lg-12 col-12'>
          مدیریت محترم مالی
         <br>
         با سلام
         <br>
         احتراما با توجه به تایید کارفرما و رضایت ایشان از عملکرد پیمانکار فوق ، آزاد سازی مبلغ قرارداد طبق صورت وضعیت پیوست بلامانع می باشد.
         <div style="padding-top:2rem;text-align:left">مدیراجرائی</div>
        </div>
    </div><!-- row -->


  </div><!-- container-fluit-->
</div>


<div mat-dialog-actions class="matDialogActions">
    <button onclick="javascript:window.print()" class="no">چاپ</button>
</div>